
import React from "react";
import { Router, Location } from "@reach/router";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { fetchDataFile } from "../components/Fetch";
import ReactHtmlParser from "react-html-parser";
import LeftColumn from "./columns/LeftColumn";
import RightColumn from "./columns/RightColumn";
import Footer from "./elements/Footer";
import Asset from './logitek/Asset';
import Popup from '../containers/popup/Popup';

import {I18nContext } from '../containers/i18n/I18nProvider';
import {translate} from '../containers/i18n';

import "../styles/logitheque.css";

class Logitheque extends React.Component {

  static contextType = I18nContext;

  constructor(props) {
    super(props);

    this.onLoadComplete = this.onLoadComplete.bind(this);
    this.setGameId = this.setGameId.bind(this);
    this.openGamePopup = this.openGamePopup.bind(this);
    this.closeGamePopup = this.closeGamePopup.bind(this);

    this.state = {
      gameId: undefined,
      gameBase: undefined,
      htmlContent: null,
      popupOpened: false
    };
  }

  componentDidMount() {
    fetchDataFile(this.props.url, "", this.onLoadComplete);
  }

  setGameId(id) {
    this.setState({gameId: id});
  }

  openGamePopup(base, item) {
    console.log("openGamePopup", base, item.id);
    if (!this.state.popupOpened) this.setState({popupOpened: true, gameId: item.id, gameBase: base, item});
  }

  closeGamePopup() {
    console.log("closeGamePopup");
    if (this.state.popupOpened) this.setState({popupOpened: false, gameId: undefined, gameBase: undefined});   
  }

  updateContainerHeight(h) {
    const mc = document.getElementById("mainContainer");
    if (mc) mc.style.height = h + 192 + "px";
  }

  onLoadComplete(data) {
    const page = ReactHtmlParser(data);
    this.setState({ htmlContent: page });
  }

  updateContent(content) {
    const d = document.getElementById("mainContainer");

    if (d) {
      const h = content ? d.clientHeight + 512 : 1000;
      return h;
    } else {
      setTimeout(this.updateContent, 250);
    }
  }

  render() {
    const content = this.state.htmlContent;
    const h = this.updateContent(content);
    const n = parseInt(h / 768);

    const cp = document.getElementById("cp");
    const s = cp ? { height: cp.clientHeight } : { height: "100%" };
    if (this.props.setFooterPosition) this.props.setFooterPosition(s);

    return (
      <>
        <div id="mainContainer" className="mainContainer">
          <LeftColumn page="logitheque" n={n} popupOpened={this.state.popupOpened}/>
          <RightColumn page="logitheque" n={n} popupOpened={this.state.popupOpened}/>
          <div id="cp" className="page logitheque">   
          <FadeTransitionRouter
              updateState={this.updateState}
              currentGameId={this.state.gameId}
            >
              <Asset
                path="/"
                menu={this.props.menu}
                updateContainerHeight={this.updateContainerHeight}
                setGameId={this.setGameId}
                lang={this.context.lang}
              />
              <Asset
                path="game/:gameId"
                updateContainerHeight={this.updateContainerHeight}
                setGameId={this.setGameId}
                lang={this.context.lang}
              />
            </FadeTransitionRouter>      
            {!this.state.gameId && <>
              {content}
              {
                this.renderGallery()
              }
              </>              
            }
          </div>
        </div>
          {!this.state.gameId && <Footer />}
          <Popup isOpen={this.state.popupOpened} 
          t={this.props.t} 
          closePopup={this.closeGamePopup}
          gameId={this.state.gameId}
          gameBase={this.state.gameBase}
          item={this.state.item}></Popup>
      </>
    );
  }

  renderGallery() {
    const menu = this.props.menu.subMenu || [];
    const list1 = menu[0].pyuta;
    const list2 = menu[1].tutor;

    return (
    <>
    <div id="gallery" className="gallery_menu">
    <div>
      <hr className="stars"/>
      <h1>{this.props.t("menu3item0")}</h1>
      <nav className="subnavgames">
        <div className="menu">
          {list1.map((item, i) => {
            return (
                <Asset key={"pyuta"+ i} 
                base={"pyuta"} 
                item={item} 
                lang={this.context.lang} 
                t={this.props.t}
                openGamePopup={this.openGamePopup}/>
            );
          })}
        </div>
      </nav>
    </div>
    <div>
    <h1>{this.props.t("menu3item0b")}</h1>
      <nav className="subnavgames">
        <div className="menu">
          {list2.map((item, i) => {
            return (
                <Asset key={"tutor"+ i} 
                base={"tutor"} 
                item={item} 
                lang={this.context.lang} 
                t={this.props.t}
                openGamePopup={this.openGamePopup}/>
            );
          })}
        </div>
      </nav>
      <hr className="stars"/>
    </div>
    </div>
  </>);
      }
}

const FadeTransitionRouter = props => {
  return (
    <Location>
      {({ location }) => {
        return (
          <TransitionGroup className="transition-group">
            <CSSTransition key={location.key} classNames="fade" timeout={500}>
              <Router location={location} className="router">
                {props.children}
              </Router>
            </CSSTransition>
          </TransitionGroup>
        );
      }}
    </Location>
  );
};

export default translate(Logitheque);
